import { render, staticRenderFns } from "./DropZonePart.vue?vue&type=template&id=3b450a1e&"
import script from "./DropZonePart.vue?vue&type=script&lang=js&"
export * from "./DropZonePart.vue?vue&type=script&lang=js&"
import style0 from "./DropZonePart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports